import { Button } from "@shopify/polaris";
import { ISODateString } from "@smartrr/shared/entities/ISODateString";

import { GettingStartedStoreAccess } from "../../../libs/store";

export function NewToSubscriptionsButton() {
  const { update } = GettingStartedStoreAccess.useActions();

  const onClick = () => {
    update(
      [
        {
          path: "onSiteSetup.migrationService",
          val: {
            completed: true,
            date: ISODateString.toString(new Date()),
          },
        },
      ],
      "migrationService"
    );
  };

  return (
    <div data-testid="migration-new-to-subscriptions">
      <Button primary onClick={onClick}>
        I am new to subscriptions
      </Button>
    </div>
  );
}
